<template>
	<div>
		<CubePage type="myorder-view" title="日报">
			<div slot="content">
				<van-sticky :offset-top="44">
					<div class="cal-box">
						<div class="cal-sc">
							<van-button type="default" size="small" @click="onBeforeDay">前一天</van-button>
							<div class="cals" @click="calshow=true">
								<div class="ri" v-if="Stime">{{Stime}}</div>
								<div v-else class="ri" style="color: #9e9e9e; font-size: 12px;">选择日期</div>
								<van-icon class="c-green" name="notes-o" size="25" />
							</div>
							<van-button type="default" size="small" @click="onNextDay">后一天</van-button>
						</div>
						<van-radio-group v-model="radiotype" @change="searchL" direction="horizontal" style="justify-content: center;
    padding: 10px 0;">
							<van-radio name="1" checked-color="#00aa00">下单时间</van-radio>
							<van-radio name="2" checked-color="#00aa00">使用时间</van-radio>
						</van-radio-group>
					</div>
				</van-sticky>
				<div style="z-index: -10;" class="box-list">
					<div class="box-item">
						<p class="i-title">数据概览</p>
						<div class="box-card">
							<div class="data-top">
								<span class="tt-h">销售金额</span>
								<p class="je c-green"><span>￥</span>{{objKl == null ?0:objKl.order_cost}}</p>
								<span class="remark">同比去年 <span class="c-green">{{objKl == null ?0:objKl.order_cost_rate}} %</span>
								</span>
							</div>
							<van-row class="row-qq" type="flex" justify="space-between">
								<van-col span="6">
									<p class="r-name">销售量</p>
									<p class="r-num">{{objKl == null ?0:objKl.order_total}}</p>
										<p class="r-b c-green">{{objKl == null ?0:objKl.order_total_rate}}%</p>
								</van-col>
								<van-col span="6">
									<p class="r-name">核销量</p>
									<p class="r-num">{{objKl == null ?0:objKl.use_total}}</p>
										<p class="r-b c-green">{{objKl == null ?0:objKl.use_total_rate}}%</p>
								</van-col>
								<van-col span="6">
									<p class="r-name">核销金额</p>
									<p class="r-num">{{objKl == null ?0:objKl.use_cost}}</p>
										<p class="r-b c-green">{{objKl == null ?0:objKl.use_cost_rate}}%</p>
								</van-col>
							</van-row>
						</div>
					</div>
					<div class="box-item">
						<p class="i-title">销售详情</p>
						<div class="box-card">
							<van-tabs type="card" class="b-tabs" color="#00aa00" v-model="activeTab">
								<van-tab title="销售量"></van-tab>
								<van-tab title="销售额"></van-tab>
							</van-tabs>
							<div :class="xsheight?'listH':''" v-if="pageTotal >0">
								<van-row class="row-qq" type="flex" justify="space-between" v-for="(item,index) in  listData" :key="index">
									<van-col span="6" class="t-name">{{item.goods_attr}}</van-col>
									<van-col span="10">
										<van-progress :percentage="activeTab== 1?item.cost_rate:item.total_rate" :pivot-text="''"
											stroke-width="6" color="#00aa00" />
									</van-col>
									<van-col span="6" class="t-name">
										<span class="c-green">{{activeTab== 1?item.cost:item.total}}</span>
										{{activeTab== 1?item.cost_rate:item.total_rate}}%
									</van-col>
								</van-row>
								<div class="moer" @click="onMoer" v-if="listData.length < pageTotal">
									<span>更多
										<van-icon name="arrow-down" />
									</span>
								</div>
							</div>
							<div v-else class="nodata">暂无数据</div>
							<div class="moer moer-r" v-if="listData.length > 3">
								<span v-if="listData.length > 3 && !xsheight" @click="xsheight=true">收起
									<van-icon name="arrow-down" />
								</span>
								<span v-else @click="xsheight=false">展开
									<van-icon name="arrow-down" />
								</span>
							</div>
						</div>
					</div>
					<div class="box-item">
						<p class="i-title">核销详情</p>
						<div class="box-card">
							<van-row class="row-qq row-t" type="flex" justify="space-between">
								<van-col span="6">人员</van-col>
								<van-col span="6">核销数量</van-col>
								<van-col span="6">核销金额</van-col>
							</van-row>
							<div :class="hxheight?'listH':''" v-if="hxpageTotal >0">
								<van-row class="row-qq" type="flex" justify="space-between" v-for="(item,index) in  hxData" :key="index">
									<van-col span="6" class="t-name">{{item.nickname}}</van-col>
									<van-col span="6">{{item.total}}</van-col>
									<van-col span="6" class="t-name">{{item.cost}}</van-col>
								</van-row>
								<div class="moer" @click="onMoerHx" v-if="hxData.length < hxpageTotal">
									<span>更多
										<van-icon name="arrow-down" />
									</span>
								</div>
							</div>
							<div v-else class="nodata">暂无数据</div>
							<div class="moer moer-r" v-if="hxData.length > 3">
								<span v-if="hxData.length > 3 && !hxheight" @click="hxheight=true">收起
									<van-icon name="arrow-down" />
								</span>
								<span v-else @click="hxheight=false">展开
									<van-icon name="arrow-down" />
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</CubePage>
		<cube-view></cube-view>
		<van-calendar v-model="calshow" @confirm="onConfirm" :min-date="minDate" :show-confirm="false" />
	</div>
</template>


<script>
	import CubeView from '@/components/TP/cube-view'
	import CubePage from '../../../TP/cube-page.vue'
	//import * as udate from '@/utils/date'
	import * as util from '@/utils/network'

	import {
		// Dialog,
		// Toast
	} from 'vant';
	export default {
		components: {
			CubePage,
			CubeView,
		},
		data() {
			return {
				calshow: false,
				activeName: 'a',
				Stime: null,
				listData: [],
				pageIndex: 1,
				pageTotal: 0,
				activeTab: 0,
				hxData: [],
				hxpageIndex: 1,
				hxpageTotal: 0,
				hxheight: false,
				xsheight: false,
				activeQTab: '销售量',
				objKl: null,
				radiotype: '1',
				minDate: new Date('2022/6/6'),
			};
		},
		created() {

		},
		mounted() {
			this.Stime = this.formatDate(new Date());
			this.searchL()
		},
		methods: {
			//概览
			getData() {
				let that = this
				var url = "/addons/litestore/api.supplier/daily"
				//这里直接调用网络接口
				util.post(url, {
						time: that.Stime,
						type: that.radiotype
					},
					function (result) {
						if (result.code == 1) {
							that.objKl = result.data
						}
					},
				);
			},
			//销售详情数据源
			getXsData() {
				let that = this
				var url = "/addons/litestore/api.supplier/daily_order"
				//这里直接调用网络接口
				util.post(url, {
						time: that.Stime,
						page: that.pageIndex,
						type: that.radiotype
					},
					function (result) {
						if (result.code == 1) {
							that.pageTotal = result.data.total
							if (that.hxpageIndex > 1) {
								that.listData = that.listData.concat(result.data.list);
							} else {
								that.listData = result.data.list
							}
						}
					},
				);
			},
			//核销详情数据源
			getHxData() {
				let that = this
				var url = "/addons/litestore/api.supplier/daily_use"
				//这里直接调用网络接口
				util.post(url, {
						time: that.Stime,
						page: that.hxpageIndex,
						type: that.radiotype
					},
					function (result) {
						if (result.code == 1) {
							that.hxpageTotal = result.data.total
							if (that.hxpageIndex > 1) {
								that.hxData = that.hxData.concat(result.data.list);
							} else {
								that.hxData = result.data.list
							}
						}
					},
				);
			},
			//加载更多
			onMoerHx() {
				this.hxpageIndex++
				this.getHxData()
			},
			//加载更多
			onMoer() {
				this.pageIndex++
				this.getXsData()
			},
			//前一天
			onBeforeDay() {
				let that = this
				let curDate = new Date(that.Stime) || new Date();
				let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000); //前一天
				that.Stime = that.formatDate(preDate);
				that.searchL()
			},
			//下一天
			onNextDay() {
				let that = this
				let curDate = new Date(that.Stime) || new Date();
				let preDate = new Date(curDate.getTime() + 24 * 60 * 60 * 1000); //前一天
				that.Stime = that.formatDate(preDate);
				that.searchL()
			},
			formatDate(date) {
				return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
			},
			onConfirm(date) {
				let that = this
				that.calshow = false;
				that.Stime = that.formatDate(date);
				that.searchL()
			},
			searchL() {
				this.clear()
				this.getData()
				this.getHxData()
				this.getXsData()
			},
			clear() {
				let that = this
				that.listData = []
				that.pageIndex = 1
				that.pageTotal = 10
				that.activeTab = 0
				that.hxData = []
				that.hxpageIndex = 1
				that.hxpageTotal = 10
				that.hxheight = false
				that.xsheight = false
				that.objKl = null
			}
		}
	}
</script>
<style lang="less" type="text/css">
	.van-sticky {
		background: #fafafa !important;
	}
</style>
<style lang="less" scoped="scoped">
	.b-tabs {
		position: relative;

		::v-deep.van-tabs__wrap {
			position: relative !important;
			top: 0;
		}

		::v-deep.van-tabs__content {
			margin: 0;
		}
	}

	.cube-page {
		background-color: #f4f4f4 !important;
	}

	.listH {
		height: 130px;
		overflow-x: hidden;
		overflow-y: scroll;
	}

	.box-list {
		.box-item {
			margin: 15px;
			font-size: 14px;

			.i-title {
				padding-bottom: 10px;
			}

			.box-card {
				padding: 10px;
				border-radius: 10px;
				background-color: #FFFFFF;

				.b-tabs {
					width: 50%;
					padding: 10px 0;
				}

				// .moer-box {
				// 	display: flex;
				// 	justify-content: space-between;
				.nodata {
					padding: 20px 0;
					text-align: center;
					color: #9e9e9e;
					font-size: 12px;
				}

				.moer {
					width: 50px;
					padding: 10px 0;
					font-size: 12px;
				}

				.moer-r {
					width: auto;
					text-align: right;
				}

				// }

				.row-qq {
					text-align: center;
					padding: 10px 0;
					align-items: center;

					.t-name {
						white-space: nowrap;
						overflow: hidden;
						font-size: 12px;
					}

					p {
						margin-top: 10px;
					}

					.r-name {
						color: #989898;
					}

					.r-num {
						font-weight: 600;
					}
				}

				.row-t {
					.van-col {
						font-size: 14px;
					}
				}

				.data-top {
					text-align: center;
					padding: 10px 0;

					.je {
						padding: 10px 0;
						font-size: 24px;

						span {
							font-size: 16px;
						}
					}

					.remark {
						font-size: 12px;
						color: #989898;
					}
				}
			}
		}
	}

	.cal-box {
		background-color: #FFFFFF;
	}

	.c-green {
		color: #00aa00;
	}

	.cal-sc {
		padding: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 14px;
		box-shadow: 5px 5px 10px #e6e6e6;

		.title {
			color: #989898;
			padding-right: 10px;
		}

		.dj {
			margin: 0 5px;
		}

		.cals {
			display: flex;
			height: 30px;
			width: 36%;
			border: 1px solid #ebedf0;
			padding: 0 8px;
			align-items: center;
			justify-content: space-between;

			.ri {
				font-weight: 600;
			}

			.van-icon {
				color: #55aa7f;
				margin-left: 10px;
				vertical-align: middle;
			}
		}
	}
</style>
